import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { ArrowRight, Shield, Search, FileText, Eye, Check } from 'lucide-react';
import { services } from '../data/mockData';

const iconMap = { Shield, Search, FileText, Eye };

const OurServicesSection = ({ onOpenContactForm }) => {
  return (
    <section id="services" data-testid="services-section" className="py-28 relative overflow-hidden">
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#06B6D4]/[0.04] rounded-full blur-[100px]" />
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <motion.div className="max-w-3xl mb-16" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#3B82F6]/10 border border-[#3B82F6]/20 mb-5">
            <span className="text-xs font-semibold text-[#3B82F6] uppercase tracking-wider">What We Offer</span>
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-5">
            Logo Trademark <span className="text-gradient">Protection</span>
          </h2>
          <p className="text-[#A1A1AA] leading-relaxed text-lg">
            Complete trademark protection for your logo. From search to registration to ongoing monitoring.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5">
          {services.map((service, index) => {
            const IconComp = iconMap[service.icon];
            return (
              <motion.div key={service.id}
                className="glass-card rounded-2xl p-8 group hover:border-[#3B82F6]/30 transition-all duration-300"
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.05 }}>
                <div className="flex items-start justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl bg-[#3B82F6]/10 flex items-center justify-center group-hover:bg-[#3B82F6]/20 transition-colors icon-hover">
                    {IconComp && <IconComp className="w-6 h-6 text-[#3B82F6]" />}
                  </div>
                  <span className="text-xs font-semibold text-[#3B82F6]/50 uppercase tracking-wider">0{index + 1}</span>
                </div>
                <h3 className="font-heading text-xl font-semibold text-white mb-3">{service.title}</h3>
                <p className="text-sm text-[#A1A1AA] leading-relaxed mb-5">{service.description}</p>
                <ul className="space-y-2 mb-6">
                  {service.features.map((f, i) => (
                    <li key={i} className="flex items-center gap-2.5">
                      <Check className="w-4 h-4 text-[#3B82F6] shrink-0" />
                      <span className="text-sm text-[#A1A1AA]">{f}</span>
                    </li>
                  ))}
                </ul>
                <Button data-testid={`service-btn-${index}`} onClick={onOpenContactForm}
                  variant="ghost" className="text-[#3B82F6] hover:text-white hover:bg-[#3B82F6]/10 font-semibold text-sm rounded-lg p-0 h-auto">
                  {service.btnText} <ArrowRight className="ml-1.5 w-4 h-4" />
                </Button>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurServicesSection;
